// Static clinic info — sourced from the Google Business listing.
export const CLINIC = {
  name: "Dent Square",
  nameHindi: "डेंट स्क्वायर",
  rating: 5.0,
  reviewCount: 77,
  phoneDisplay: "070075 21904",
  phoneTel: "+917007521904",
  whatsappLink: "https://wa.me/917007521904",
  address:
    "1/353, Viram Khand, Viram Khand 1, Gomti Nagar, Lucknow, Uttar Pradesh 226010",
  city: "Lucknow",
  hours: "Open · Closes 9 pm",
  hoursDetailed: [
    { day: "Monday", time: "10:00 am – 9:00 pm" },
    { day: "Tuesday", time: "10:00 am – 9:00 pm" },
    { day: "Wednesday", time: "10:00 am – 9:00 pm" },
    { day: "Thursday", time: "10:00 am – 9:00 pm" },
    { day: "Friday", time: "10:00 am – 9:00 pm" },
    { day: "Saturday", time: "10:00 am – 9:00 pm" },
    { day: "Sunday", time: "11:00 am – 7:00 pm" },
  ],
  womenOwned: true,
  mapsLink:
    "https://www.google.com/maps/search/?api=1&query=Dent+Square+Gomti+Nagar+Lucknow",
  mapsEmbed:
    "https://www.google.com/maps?q=Dent+Square+Gomti+Nagar+Lucknow&output=embed",
};

export const SERVICES = [
  {
    title: "General Dentistry",
    desc: "Routine check-ups, fillings, and preventive care for the whole family.",
    span: "lg:col-span-5 lg:row-span-2",
    tone: "primary",
  },
  {
    title: "Painless Treatment",
    desc: "Modern anesthesia and gentle techniques — comfort first, always.",
    span: "lg:col-span-4",
    tone: "accent",
  },
  {
    title: "Orthodontics",
    desc: "Braces, aligners and bite correction with Dr. Uday Sharma.",
    span: "lg:col-span-3",
    tone: "muted",
  },
  {
    title: "Tooth Extraction",
    desc: "Quick, safe, and surprisingly comfortable.",
    span: "lg:col-span-3",
    tone: "muted",
  },
  {
    title: "Root Canal",
    desc: "Save your natural tooth with single-sitting RCT.",
    span: "lg:col-span-4",
    tone: "muted",
  },
  {
    title: "Cosmetic Dentistry",
    desc: "Whitening, veneers and smile design crafted to your face.",
    span: "lg:col-span-5",
    tone: "primary",
  },
  {
    title: "Cleaning & Polishing",
    desc: "Ultrasonic scaling for a fresh, healthy mouth.",
    span: "lg:col-span-4",
    tone: "muted",
  },
  {
    title: "Pediatric Dentistry",
    desc: "Friendly care that turns first visits into happy memories.",
    span: "lg:col-span-3",
    tone: "accent",
  },
];

export const TEAM = [
  {
    name: "Dr. Mohit Singh Raghuvanshi",
    role: "Co-Founder · Dental Implants & RCT",
    bio: "Specialist in dental implants and single-sitting root canal treatment. Known for clear explanations and genuinely painless procedures.",
    image:
      "https://customer-assets.emergentagent.com/job_smile-square/artifacts/eu2f4tlv_photo.png",
  },
  {
    name: "Dr. Priyanka Singh",
    role: "Co-Founder · Dental Conservation",
    bio: "Focused on conservative dentistry and personalised treatment plans that preserve your natural smile for the long run.",
    image:
      "https://images.pexels.com/photos/31043312/pexels-photo-31043312.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const REVIEWS = [
  {
    name: "Sumit Kumar",
    when: "9 months ago",
    text: "Best dental doctor I met. Best treatment, best guidance. Dr. Mohit is one of the best dentists in Lucknow — he has in-depth knowledge and explains the procedure so the patient understands everything.",
    initial: "S",
  },
  {
    name: "Aparajita Pandey",
    when: "3 months ago",
    text: "The experience here was great. The doctor is very cooperative and the treatment was done very smooth and professional.",
    initial: "A",
  },
  {
    name: "Firdous Mansoori",
    when: "3 months ago",
    text: "Service was great — all the problems were solved with lots of effort by the doctors, especially Anita ma'am. They look into every detail carefully. Must visit the clinic.",
    initial: "F",
  },
  {
    name: "Patient",
    when: "review",
    text: "The office is in a great location, making visits convenient and stress free.",
    initial: "P",
  },
  {
    name: "Patient",
    when: "review",
    text: "Dr. Uday Sharma — best doctor for ortho, very supportive, best experience.",
    initial: "U",
  },
  {
    name: "Patient",
    when: "review",
    text: "Excellent and top clinic, good staff, great services.",
    initial: "E",
  },
];

export const HIGHLIGHTS = [
  { label: "Google Rating", value: "5.0★" },
  { label: "Verified Reviews", value: "77+" },
  { label: "Years of Care", value: "10+" },
  { label: "Women-Owned", value: "Yes" },
];
